<div
    #app
    class="relative isolate flex h-screen min-h-0 w-screen flex-col overflow-hidden print:overflow-visible"
    (scroll)="app.scrollTop = 0"
>
    <span class="sr-only" id="navigation-focus-sentinel" tabindex="-1"></span>
    <interacta-skip-links />
    @let user = currentUser();
    @if (user && showHeader()) {
        <interacta-header
            class="shrink-0"
            [currentTheme]="theme()"
            [customerLogoSrc]="logo"
            [iconMode]="iconMode()"
            [user]="user"
            (changeLanguage)="changeLanguage($event)"
            (changeTheme)="changeTheme($event)"
            (logout)="logout()"
            (openAppInfo)="isAppInfoDialogOpen.set(true)"
            (openNotificationsSettings)="openNotificationsSettings()"
            (openProfile)="openProfile()"
        />
    }
    @if (user) {
        <interacta-bottom-menu
            class="fixed right-0 bottom-0 z-10 print:hidden"
        />
    }

    <div class="z-0 flex min-h-0 grow">
        @if (user && showSidebar()) {
            @let isLeftMenuOpen = isMd() && (leftMenuUI()?.isOpen ?? false);
            <nav
                class="shrink-0 overflow-x-hidden transition-width duration-300"
                data-testid="sidebar-nav"
                [attr.aria-label]="'SIDEBAR.NAV_LABEL' | translate"
                [ngClass]="isLeftMenuOpen ? 'w-252' : 'w-64'"
            >
                <interacta-sidebar
                    class="block h-full"
                    [currentTheme]="theme()"
                    [expanded]="isLeftMenuOpen"
                />
            </nav>
        }
        <main class="min-w-0 grow">
            <router-outlet />
        </main>

        @if (user && aiConvoEnabled()) {
            <div
                #aiSidePanel
                class="relative max-w-1/2 shrink-0"
                [ngClass]="{
                    'transition-width duration-300': !isAISidePanelResizing(),
                    'overflow-hidden': !isAISidePanelOpen(),
                    'pr-12 pb-12': isAISidePanelOpen(),
                }"
                [style.width.px]="
                    isAISidePanelOpen()
                        ? aiSidePanelWidth() || AI_SIDEPANEL_MINWIDTH_PX
                        : 0
                "
            >
                @if (isAISidePanelOpen()) {
                    <interacta-horizontal-panel-resizer
                        class="absolute top-0 bottom-0 left-0 w-16 -translate-x-16"
                        [minWidth]="AI_SIDEPANEL_MINWIDTH_PX"
                        [panel]="aiSidePanel"
                        [side]="'right'"
                        (resizing)="isAISidePanelResizing.set($event)"
                        (widthChanged)="widthResized($event)"
                    />
                    <interacta-ai-convo-side-panel
                        class="h-full"
                        [currentUser]="user"
                        [expandedSidebar]="
                            aiSidePanelWidth() >= AI_SIDEPANEL_EXPANDED_PX
                        "
                        (expandSidebar)="
                            $event
                                ? widthResized(AI_SIDEPANEL_EXPANDED_PX)
                                : widthResized(AI_SIDEPANEL_MINWIDTH_PX)
                        "
                    />
                }
            </div>
        }
    </div>
</div>

<interacta-layer />
<interacta-mobile-banner />
<interacta-confirm-dialog />
<interacta-license-upgrade-dialog />
<interacta-user-profile-dialog />
<interacta-group-info-dialog />
<interacta-hashtag-info-dialog />
<interacta-table-info-dialog />
<interacta-attachments-versions-dialog />
<interacta-tip-overlay />
<interacta-toast-notification-overlay />
<interacta-comment-fullscreen-editor />
<interacta-loading-layer [src]="theme().mode | appLogo" />
<interacta-carousel-container [canShowCarousel]="canShowCarousel()" />
<interacta-links-dialog
    [isOpen]="linksDialogState.isOpen()"
    [normalizedSections]="linksDialogState.normalizedSections() ?? []"
    (closing)="linkDialogStateService.close()"
    (loadError)="temporaryLinkErrorHandlerService.handleUsefulLinkError($event)"
/>
<interacta-collections-dialog />
<interacta-relations-dialog />
<interacta-app-info-dialog
    [isOpen]="isAppInfoDialogOpen()"
    (closing)="isAppInfoDialogOpen.set(false)"
/>
